import './index.css'

const MainMenuItemContainer = ({ children, active }: { children: any; active: boolean }) => {
  const classes = ['main-menu-item', active ? 'active' : null]
  return <div className={classes.filter((cl) => !!cl).join(' ')}>{children}</div>
}

export default MainMenuItemContainer
